import React from 'react';
import { Link } from 'react-router-dom';
import './MarketingConsent.css';

/**
 * Marketing opt-in checkbox with disclaimer copy.
 * Shared by every form on the site that collects an email address so the
 * restaurant can market to people who have agreed to hear from us.
 */
const MarketingConsent = ({ id = 'marketingOptIn', checked, onChange, disabled = false, required = false }) => {
  return (
    <div className="marketing-consent">
      <input
        type="checkbox"
        id={id}
        name="marketingOptIn"
        checked={checked}
        onChange={onChange}
        disabled={disabled}
        required={required}
        className="marketing-consent-checkbox"
      />
      <label htmlFor={id} className="marketing-consent-label">
        <span className="marketing-consent-text">
          Yes, I'd like to receive emails from Drake's about events, live music, specials, and other news.
          {required && <span className="marketing-consent-required">*</span>}
        </span>
        <span className="marketing-consent-disclaimer">
          By checking this box you agree to receive marketing emails from Drake's. You can unsubscribe at any time
          using the link in any email. We will never sell or share your email address. See our{' '}
          <Link to="/privacy-policy">Privacy Policy</Link>.
        </span>
      </label>
    </div>
  );
};

export default MarketingConsent;
